import { render, staticRenderFns } from "./DashboardSummary.vue?vue&type=template&id=2e0a5ed1&scoped=true&"
import script from "./DashboardSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardSummary.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSummary.vue?vue&type=style&index=0&id=2e0a5ed1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a5ed1",
  null
  
)

export default component.exports